import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { Login } from "../model/login";
import conf from "../_models/conf.json";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};
@Injectable({
  providedIn: "root",
})
export class ApiLoginService {
  //public urlApi = 'http://localhost:8000/index.php/';
  // public urlApi = "https://nextsysplay-api.mncplay.id/frontend/web/index.php/";
  private urlApi = conf.urlApidev; //Dev
  // private urlApi = conf.urlApilocal; //lsocal
  // private urlApi = conf.urlApiprod; //Prod
  // staging
  // public urlApi = 'http://b2b-api-dev.mncplaymedia.com/frontend/web/index.php/';
  // public urlApi = 'https://b2b-api-dev.mncplay.id/frontend/web/index.php/';
  //production
  // public urlApi = 'http://b2b-api.mncplaymedia.com/frontend/web/index.php/';
  //production PUblick
  //public urlApi = 'https://b2b-api.mncplay.id/frontend/web/index.php/';

  private currentUserSubject: BehaviorSubject<Login>;
  public currentUser: Observable<Login>;
  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<Login>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): Login {
    return this.currentUserSubject.value;
  }
  /** POST **/
  loginUser(hero: Login): Observable<Login> {
    console.log(JSON.stringify(hero));
    console.log(this.urlApi + "login");
    return this.http
      .post<any>(this.urlApi + "apis/login", JSON.stringify(hero), httpOptions)
      .pipe(
        map((user) => {
          // login successful if there's a jwt token in the response
          console.log(user);

          if (user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem("currentUser", JSON.stringify(user.data));
            this.currentUserSubject.next(user.data);
          }
          return user.data;
        })
      );
  }

  logout() {
    localStorage.removeItem("currentUser");
    this.currentUserSubject.next(null);
  }
}
